import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Divider from '@material-ui/core/Divider'
import DialogTitle from '@material-ui/core/DialogTitle'
import ServiceLineForm from '../../../ServiceLine/Form'
import { StyledActions, StyledContent } from '../styles'
import { useOnboarding } from '../../../../../contexts/OnboardingContext'
import { DialogContentText } from '@material-ui/core'

export default function ServiceLineDialog(props) {
  const { open, handleClose, data, setPropChange } = props
  const { formRef } = useOnboarding()

  const updateForm = async () => {
    await formRef.current.handleSubmit()
    setPropChange(true)
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>Primary Role</DialogTitle>
      <DialogContentText>
        {
          'Please select the role that best describes your experience. Clients we identify for you are based on your overall experience and preferences and not determined by this title.'
        }
      </DialogContentText>
      <StyledContent>
        <ServiceLineForm initialValues={data} />
      </StyledContent>
      <Divider />
      <StyledActions>
        <Button variant="outlined" onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={updateForm} color="primary">
          Save
        </Button>
      </StyledActions>
    </Dialog>
  )
}
